import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { filter, Observable, of } from 'rxjs';
import { stepFadeInAnimation } from './payment/utilities';
import { IsLoadingService } from '@service-work/is-loading';
import { AuthService } from '../core';

@Component({
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss'],
  animations: [stepFadeInAnimation],
})
export class FeatureComponent implements OnInit {
  public isLoading: Observable<boolean> = of(false);

  constructor(
    private isLoadingService: IsLoadingService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {
    this.isLoading = this.isLoadingService.isLoading$();

    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationCancel ||
            event instanceof NavigationStart ||
            event instanceof NavigationError ||
            event instanceof NavigationEnd
        )
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.isLoadingService.add();
          return;
        }
        this.isLoadingService.remove();
      });
  }

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe((routeQueryParams) => {
      const authBoxParam = routeQueryParams.get('authBox');
      const redirectPath = routeQueryParams.get('redirectTo');

      if (authBoxParam) {
        this.authService.checkOrOpenAuthBox((data) => {
          if (redirectPath) {
            setTimeout(() => {
              this.router.navigate([redirectPath]);
            }, 1000);
          }
        });
      }
    });
  }

  public cancelLoading() {
    this.isLoadingService.clear();
  }
}
